import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '15px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '200px',
  },
  maps: {
    paddingTop: '15px',
    minHeight: '400px',
  },
  field: {
    padding: '15px 15px 0px 15px',
    bottom: 15,
    position: 'absolute',
  },
  icon: {
    color: '#999',
    marginRight: theme.spacing(2),
  },
  searchIcon: {
    color: '#FF9000',
  },
  button: {
    display: 'flex',
    justifyContent: 'space-around',
    width: 'calc(100% - 30px)',
    height: '50px',
    position: 'fixed',
    bottom: 15,
    borderRadius: 5,
    backgroundColor: '#F97F11',
    color: '#FFF',
    '&:hover': {
      backgroundColor: '#F97F11',
    },
  },
  modalAddress: {
    width: '100%',
    background: '#FFF',
    position: '',
    display: 'flex',
    padding: 20,
  },
  formAddress: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space around',
    marginBottom: 10,
  },
  buttonConfirmAddress: {
    display: 'flex',
    width: '100%',
    height: '50px',
    borderRadius: 5,
    backgroundColor: '#F97F11',
    color: '#FFF',
  },
  formAddressTitle: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  inputNumber: {
    width: '60px',
    maxWidth: '80px',
  },
  inputComplement: {
    padding: 5,
    marginLeft: 10,
    maxWidth: '150px',
    width: '250px',
  },
  addressesItem: {
    width: '100%',
    background: '#FFF',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '15px',
    minHeight: '70px',
    borderRadius: 6,
    marginTop: 2,
    marginBottom: 2,
  },
  addressesItemBody: {
    flex: '1',
    marginLeft: '15px',
    display: 'flex',
    flexDirection: 'column',
  },
  addressesItemFields: {
    fontSize: 13,
    color: '#999',
  },
  searchContainer: {
    marginTop: '10px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    pading: '5px',
    alignItems: 'center',
    borderBottom: '0.5px solid #eee',
  },
  searchContainerIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  searchFromMapButton: {
    borderColor: '#eee',
    marginTop: 10,
    color: '#FF9000',
    width: '100%',
  },
  searchProgress: {
    color: '#FF9000',
  },
  cssFocused: {
    // borderColor: '#FF9000',
    color: '#FF9000',
    borderColor: 'yellow !important',
  },
}));

export default useStyles;
